app.controller('redirectController',
  ['$route', '$window', '$timeout', '$routeParams', '$location', 'authHelper', 'portalHelper',
    function ($route, $window, $timeout, $routeParams, $location, authHelper, portalHelper) {

      $timeout(function () {
        let target = $route.current.targetURL;

        if (!target) {
          if ($location.path().indexOf('/Administration') === 0 ||
            $location.path().indexOf('/Admin') === 0) {
            target = 'admin/#' + $location.path();
          } else if ($location.path().indexOf('/Client') === 0 ||
            $location.path().indexOf('/SurveyDoesNotExist') === 0) {
            target = 'client/#' + $location.path();
          } else if ($location.path().indexOf('/Payers') === 0) {
            // Payer path: check whether this payer should use the new Angular portal.
            // If so, redirect there preserving the path. Otherwise fall through to the legacy payer sub-app.
            // A timeout safety net guards against a hung portal-version probe by falling back to
            // the legacy portal. This is safe for both payer types: legacy-flag payers stay on
            // their correct portal, and new-portal payers will be re-routed once the old portal
            // sub-app's own portalReady() check runs and the API recovers (path is preserved).
            let handled = false;
            const fallbackToLegacy = function () {
              if (handled) {
                return;
              }
              handled = true;
              $window.location.href = 'payer/#' + $location.path();
            };
            portalHelper.checkAndRedirectToNewPortalIfPayer($location.path()).then(
              function (redirecting) {
                if (redirecting) {
                  handled = true;
                } else {
                  fallbackToLegacy();
                }
              }
            );
            $timeout(fallbackToLegacy, 3000);
            return;
          } else if ($location.path().indexOf('/open_document') === 0) {
            target = 'document/#' + $location.path();
          } else if ($location.path().indexOf('/Login') === 0 ||
            $location.path() === '/' ||
            $location.path() === '/#' ||
            $location.path() === '' ||
            $location.path().indexOf('/Login/Return') === 0) {
            target = 'login/#' + $location.path();
          } else if ($location.path() === '/Help' || $location.path() === '/FAQs') {
            authHelper.getUserTypeName().then(
              function (result) {
                const user_type = result.data.user_type_name;
                target = user_type + '/#' + $location.path();
                if ($routeParams.returnUrl) {
                  target = target.replace(':returnUrl',
                    encodeURIComponent(encodeURIComponent(decodeURIComponent($routeParams.returnUrl))));
                }
                $window.location.href = target;
              }
            );
            return;
          }
        }

        $window.location.href = target;

      }, 500);
    }]
);
